export const MAX_SEARCH_RESULTS = 10000;
